<template>
  <div class="row" id="footer">
    <div class="col-lg-1 col-md-2 sol-ms-0 col-md-0"></div>
    <div class="col-lg-10 col-md-8 col-ms-10 col-xs-12">
      <div class="row">
        <div class="col-xs-12 col-sm-6 col-md-2">
          <h4>{{this.$root.language == 1?'走进安仑':'Get to know us'}}</h4>
          <p>{{this.$root.language == 1?'公司简介':'Company Profile'}}</p>
          <p>{{this.$root.language == 1?'发展历程':'Development History'}}</p>
          <p>{{this.$root.language == 1?'资质荣誉':'Qualifications and honors'}}</p>
<!--          <p>{{this.$root.language == 1?'合作伙伴':'Cooperative partner'}}</p>-->
        </div>
        <div class="col-xs-12 col-sm-6 col-md-2">
          <h4>{{this.$root.language == 1?'新闻资讯':'News information'}}</h4>
          <p>{{this.$root.language == 1?'公司新闻':'Company News'}}</p>
          <p>{{this.$root.language == 1?'员工风采':'Staff style'}}</p>
          <p>{{this.$root.language == 1?'环保公示':'Environmental'}}</p>
          <p>{{this.$root.language == 1?'社会责任':'Responsibility'}}</p>
          <p>{{this.$root.language == 1?'乌海安仑':'Wuhai Anlun'}}</p>
        </div>
        <!-- <div class="clearfix visible-xs-block"></div>
        <div class="col-xs-12 col-sm-6 col-md-2">
          <h4>产品中心</h4>
          <p>介绍视频</p>
          <p>管理模式</p>
          <p>平台目标</p>
          <p>功能模块</p>
        </div> -->
        <div class="col-xs-12 col-sm-6 col-md-3">
          <h4>{{this.$root.language == 1?'联系我们':'Contact us'}}</h4>
          <p>{{this.$root.language == 1?'电话':'Telephone'}}：021-50799991</p>
          <p>{{this.$root.language == 1?'邮箱':'E-mail'}}：anlun@sxygjh.com</p>
          <p>{{this.$root.language == 1?'山西地址：河津市僧楼镇河津经济技术开发区东区':'Hejin City Sanglou town Hejin economic and technological development Zone east'}}</p>
          <p>{{this.$root.language == 1?'上海地址：上海市浦东新区王桥路999号1024幢':'Shanghai address：Building 1024, 999 Wangqiao Road, Pudong, Shanghai'}}</p>
          <p>{{this.$root.language == 1?'邮编':'Postal Code'}}：043300</p>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-3">
          <h4>{{this.$root.language == 1?'相关链接':'Related links'}}</h4>
          <p><a href="http://www.cria.org.cn/" style="color: #ffffff;">{{this.$root.language == 1?'中国橡胶工业协会':'China Rubber Industry Association'}}</a></p>
          <p><a href="http://www.cria.org.cn/detail/32542.html?t=2" style="color: #ffffff;">{{this.$root.language == 1?'中国橡胶工业协会炭黑分会':'Carbon Black Branch of China Rubber Industry Association'}}</a></p>
          <p><a href="http://admin.cria.org.cn/" style="color: #ffffff;">{{this.$root.language == 1?'中国橡胶网':'China Rubber Network'}}</a></p>
          <!-- <p>电话：0359-5328001</p>
          <p>地址：河津市王家岭循环经济工业园区内</p>
          <p>邮编：043300</p> -->
        </div>
        <div class="col-xs-12 col-sm-6 col-md-2">
          <p>{{this.$root.language == 1?'安仑公众号':'Anlun official account'}}：</p>
          <img src="../assets/img/erweima.png" style="width: 70%;"/>
        </div>
      </div>
    </div>
    <div class="col-lg-1 col-md-1 col-ms-0 col-xs-0"></div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
};
</script>

<style scoped>
#footer {
  padding-top: 30px;
  text-align: center;
  color: #ffffff;
}
</style>